import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = () => {
  const token = useSelector(
    (state) => state?.customerJourneyDetails?.customerDetails?.token
  );

  if (!token) {
    return <Navigate to="/apply-now" replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;